import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import type { ResApplicantDetail } from '@/lib/queries/business/v1/types'

export const getApplicantDetailQuery = (pathId: string) => {
  return queryOptions<ResApplicantDetail>({
    queryKey: ['applicant', { pathId }],
    queryFn: () => w.get(`/business/v1/applicant/${pathId}`).json(),
  })
}
